import {createIntl, createIntlCache} from "react-intl";
import {appContext} from "./Contexts";
import MessagesUtils from "./sal-ui/MessagesUtils";
import messages_cs_properties from "./translations/messages_cs.properties";
import messages_en_properties from "./translations/messages_en.properties";
import moment from "moment";
import dayjs from "dayjs";

const messages: any = {
    'cs': {},
    'en': {},
}

const cache = createIntlCache();

export function createAppIntl(locale: string) {
    return createIntl({locale: locale, messages: messages[locale]}, cache)
}

export let intl = createAppIntl(appContext.language)

export function updateLocaleResources(locale: string) {
    intl = createAppIntl(locale)

    moment.locale(locale);

    dayjs.locale(locale);
}

export function loadMessages(): Promise<void> {
    return Promise.all([
        MessagesUtils.loadMessages(messages_cs_properties),
        MessagesUtils.loadMessages(messages_en_properties)
    ]).then((values) => {
        messages.cs = values[0];
        messages.en = values[1];

        intl = createAppIntl(appContext.language)
    });
}
